export default __webpack_public_path__ + "static/media/dashboard.67f45aaf.svg";